const EVENT_NAME = 'tcm-journey-updated';

function storageKey(userId) {
  return `tcm_journey_v1_${userId || 'anon'}`;
}

export function listarJornada(userId) {
  try {
    return JSON.parse(localStorage.getItem(storageKey(userId)) || '[]');
  } catch {
    return [];
  }
}

export function salvarNaJornada(userId, entry) {
  const atual = listarJornada(userId);
  const novo = { id: `journey_${Date.now()}`, criadoEm: new Date().toISOString(), privacidade: 'equipe', ...entry };
  localStorage.setItem(storageKey(userId), JSON.stringify([novo, ...atual].slice(0, 8)));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
  return novo;
}

export function excluirDaJornada(userId, entryId) {
  localStorage.setItem(storageKey(userId), JSON.stringify(listarJornada(userId).filter(item => item.id !== entryId)));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function observarJornada(callback) {
  const listener = () => callback();
  window.addEventListener(EVENT_NAME, listener);
  window.addEventListener('storage', listener);
  return () => {
    window.removeEventListener(EVENT_NAME, listener);
    window.removeEventListener('storage', listener);
  };
}
